// For demo purposes we are adding all locales, you SHOULD NOT DO THIS IN PRODUCTION
import { configure } from "vee-validate";
import { localize } from "@vee-validate/i18n";
import _ from "lodash";

const codes = [
  // "ar",
  // "et",
  // "ja",
  // "nn_NO",
  // "sr_Latin",
  // "az",
  // "eu",
  // "ka",
  // "pl",
  // "sv",
  // "bg",
  // "fa",
  // "ko",
  // "pt_BR",
  // "th",
  "ca",
  // "fi",
  // "lt",
  "pt_PT",
  // "tr",
  // "cs",
  // "fr",
  // "lv",
  // "ro",
  // "uk",
  // "da",
  "he",
  // "mn",
  // "ru",
  // "vi",
  // "de",
  // "hr",
  // "ms_MY",
  // "sk",
  // "zh_CN",
  // "el",
  // "hu",
  // "nb_NO",
  // "sl",
  // "zh_TW",
  "en",
  // "id",
  // "ne",
  // "sq",
  "es"
  // "it",
  // "nl",
  // "sr"
];

export const setValidationMessages = async () => {
  const locales = await Promise.all(
    codes.map(code => import(`@vee-validate/i18n/dist/locale/${code}.json`))
  );

  const dictionary = locales.reduce((dict, curr, idx) => {
    const code = codes[idx];
    dict[code] = curr;

    return dict;
  }, {});

  const customDictionary = {
    en: {
      phone: "The {field} field must be a valid phone number",
      dni: "Wrong ID, invalid format",
      nie: "Wrong ID, invalid format"
    },
    ca: {
      phone: "El camp {field} ha de ser un número de telèfon vàlid",
      dni: "ID incorrecte, format no vàlid",
      nie: "ID incorrecte, format no vàlid"
    },
    es: {
      phone: "El campo {field} debe ser un número de teléfono válido",
      dni: "ID incorrecta, formato no válido",
      nie: "ID incorrecta, formato no válido"
    },
    he: {
      phone: "השדה {field} חייב להיות מספר טלפון חוקי",
      dni: "מזהה שגוי, פורמט לא חוקי",
      nie: "מזהה שגוי, פורמט לא חוקי"
    },
    // eslint-disable-next-line @typescript-eslint/camelcase
    pt_PT: {
      phone: "O campo {field} deve ser um número de telefone válido",
      dni: "ID errado, formato inválido",
      nie: "ID errado, formato inválido"
    }
    // // eslint-disable-next-line @typescript-eslint/camelcase
    // zh_CN: {
    //   phone: "{field}字段必须是有效的电话号码"
    // }
  };

  _.keys(customDictionary).forEach(k => {
    _.set(
      dictionary,
      `${k}.messages`,
      _.assign(
        dictionary[k].messages,
        customDictionary[k as "en" | "ca" | "es" | "he" | "pt_PT"]
      )
    );
  });

  configure({
    generateMessage: localize(dictionary)
  });
};
